"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOriPackageJson = isOriPackageJson;
var _types = require("../types");
function isOriPackageJson(value) {
  return _types.oriPackageJsonSchema.safeParse(value).success;
}
